/* lystia-hero.js - <lystia-hero> hero-слайдер Головної (T-E6-02, parity/home.md §2). */
(function () {
  'use strict';
  if (customElements.get('lystia-hero')) return;

  class LystiaHero extends HTMLElement {
    connectedCallback() {
      var self = this;
      this.track = this.querySelector('[data-hero-track]');
      if (!this.track) return;
      this.dots = Array.prototype.slice.call(this.querySelectorAll('[data-hero-dot]'));
      this.n = this.track.children.length;
      this.cur = 0;
      this.timer = null;
      this.paused = false;
      this.visible = true;
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var debounce = (document.lystia && document.lystia.debounce) || function (fn, ms) {
        var t; return function () { clearTimeout(t); t = setTimeout(fn, ms); };
      };

      this._mark = function () {
        if (self._anim) return;
        var i = Math.round(self.track.scrollLeft / (self.track.clientWidth || 1));
        self.cur = i;
        if (self._loadAhead && i > 0) self._loadAhead(i);
        self.dots.forEach(function (d, k) {
          d.classList.toggle('is-active', k === i);
          d.setAttribute('aria-selected', k === i ? 'true' : 'false');
        });
        Array.prototype.forEach.call(self.track.children, function (s, k) { s.classList.toggle('is-active', k === i); });
      };
      this._onScroll = debounce(this._mark, 130);
      this.track.addEventListener('scroll', this._onScroll, { passive: true });
      this.track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); self.go(self._pos() + 1, true); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); self.go(self._pos() - 1, true); }
      });
      var prev = this.querySelector('[data-hero-prev]');
      var next = this.querySelector('[data-hero-next]');
      if (prev) prev.addEventListener('click', function () { self.go(self._pos() - 1, true); });
      if (next) next.addEventListener('click', function () { self.go(self._pos() + 1, true); });
      this.dots.forEach(function (d, k) { d.addEventListener('click', function () { self.go(k, true); }); });

      this._pause = function () { self.paused = true; };
      this._resume = function () { self.paused = false; self._restart(); };
      this.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') self._pause(); });
      this.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') self._resume(); });
      this.addEventListener('focusin', this._pause);
      this.addEventListener('focusout', this._resume);
      this.addEventListener('touchstart', this._pause, { passive: true });
      this.addEventListener('touchend', function () { setTimeout(self._resume, 4000); }, { passive: true });

      if ('IntersectionObserver' in window) {
        this._io = new IntersectionObserver(function (es) { self.visible = es[0].isIntersecting; }, { threshold: 0.4 });
        this._io.observe(this);
      }
      requestAnimationFrame(function () { self._mark(); self._restart(); });

      /* Слайди 2+ не вантажаться разом із першим: після load+idle - лише слайд 2; далі - на 1 слайд наперед при взаємодії/переході. */
      this._loadSlide = function (k) {
        var sl = self.track.children[((k % self.n) + self.n) % self.n];
        if (!sl) return;
        sl.querySelectorAll('[data-srcset]').forEach(function (el) { el.setAttribute('srcset', el.getAttribute('data-srcset')); el.removeAttribute('data-srcset'); });
        sl.querySelectorAll('[data-hero-lazy]').forEach(function (img) {
          var s = img.getAttribute('data-src');
          if (s) img.setAttribute('src', s);
          img.removeAttribute('data-src');
          img.removeAttribute('data-hero-lazy');
          img.loading = 'eager';
        });
      };
      this._loadAhead = function (k) { self._loadSlide(k); self._loadSlide(k + 1); };
      ['pointerdown', 'touchstart', 'keydown'].forEach(function (t) { self.addEventListener(t, function () { self._loadAhead(self.cur + 1); }, { passive: true }); });
      var later = function () { (window.requestIdleCallback || function (f) { setTimeout(f, 200); })(function () { self._loadSlide(1); }); };
      if (document.readyState === 'complete') later(); else window.addEventListener('load', later, { once: true });
    }

    disconnectedCallback() {
      clearInterval(this.timer);
      if (this._io) this._io.disconnect();
    }

    _pos() {
      return Math.round(this.track.scrollLeft / (this.track.clientWidth || 1));
    }

    go(i, user) {
      var self = this, n = this.n, from = this._pos();
      i = ((i % n) + n) % n;
      this.cur = i;
      this._loadAhead(i);
      var left = i * this.track.clientWidth;
      var instant = this.reduced || Math.abs(i - from) > 1; /* перехід через край (3 -> 0, 0 -> 3) без прогортання всіх слайдів */
      clearTimeout(this._animT);
      this._anim = true;
      this.track.style.scrollSnapType = 'none';
      this.track.scrollTo({ left: left, behavior: instant ? 'auto' : 'smooth' });
      this._animT = setTimeout(function () {
        self._anim = false;
        self.track.style.scrollSnapType = '';
        self.track.scrollTo({ left: left, behavior: 'auto' });
        self._mark();
      }, instant ? 60 : 520);
      if (user) this._restart();
    }

    _restart() {
      var self = this;
      clearInterval(this.timer);
      if (!this.reduced && this.n > 1) {
        this.timer = setInterval(function () {
          if (!self.paused && self.visible && !document.hidden) self.go(self.cur + 1);
        }, 5500);
      }
    }
  }
  customElements.define('lystia-hero', LystiaHero);
})();
